import { FC } from 'react'
import { Controller } from 'react-hook-form'
import { theme } from 'theme'

import { Checkbox, ListItemText, MenuItem, TextField } from '@mui/material'

export interface Option {
  label: string
  value: string
}

interface Props {
  control: any
  name: string
  errors: any
  label: string
  options: Option[]
  disabled?: boolean
  loading?: boolean
  placeholder?: string
  rules?: any
}

const MultiSelectAutocomplete: FC<Props> = ({
  control,
  name,
  label,
  errors,
  options,
  disabled = false,
  loading = false,
  placeholder = '',
  rules,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value = [] }, fieldState: { error } }) => (
        <TextField
          select
          placeholder={placeholder}
          error={!!errors[name]}
          SelectProps={{
            multiple: true,
            value: value,
            onChange,
            renderValue: (selected) =>
              (selected as string[])
                .map((value) => options.find((option) => option.value === value)?.label || value)
                .join(', '),
          }}
          fullWidth
          label={label}
          helperText={errors[name]?.message}
          disabled={disabled || loading}
        >
          {options.map((option) => (
            <MenuItem
              sx={{
                '&.Mui-selected': {
                  ':hover': {
                    bgcolor: theme.palette.primary.light,
                    color: theme.palette.text.primary,
                  },
                  bgcolor: 'transparent',
                  color: theme.palette.text.primary,
                },
              }}
              key={option.value}
              value={option.value}
            >
              <Checkbox checked={value.includes(option.value)} />
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  )
}

export default MultiSelectAutocomplete
